<template>
  <el-dialog :visible.sync="show" width="30%" :before-close="closeDialog" :close-on-click-modal="false">
    <el-form>

      <el-form-item label="司机段位:" label-width='120px'>
        <el-select v-model="submit_data.dan" style="width: 150px; margin-right: 20px;">
          <el-option v-for="item in dan_select" :label="item.alias" :value="item.val">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.submit_data.driver_code = _this.data;


        this.$post(
            "/driver/getDriverPointsDetails", {
              driver_code: this.data
            }
          )
          .then(res => {


            this.dan_select = res.data.dan.select_array;

            // this.dan = res.data.dan.alias;

            this.submit_data.dan = Number(res.data.dan.val);


          })




      },
    },
    data() {
      return {


        show: false,


        dan_select: [],

        // 表单数据
        submit_data: {
          driver_code: '',
          dan: ''
        },

        submit_rules: {
          driver_code: {
            placeholder: '公司名称100字以内',
            rules: {
              required: true,
              message: '角色名100个汉字以下',
              regulation: 'special',
              rulesData: 'driver_code'
            }
          },
          dan: {
            placeholder: '段位',
            rules: {
              required: true,
              message: '段位错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          }
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {
        _this.show = false;

        _this.submit_data = {
          driver_code: '',
          dan: ''
        };

      },
      // 提交
      onSubmit() {
        _this.$post(
            "/driver/editDriverDanSubmit",
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();

            _this.$message.success({
              message: res.msg,
              duration: 1500
            });
          }).catch(res => {

          })
      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }
</style>